import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { showAlert } from '../../actions'
import { index, patch } from '../../apis'
import { formatError } from '../../utils'
import { useIsMounted } from '../../hooks'
import makeStyles from '@mui/styles/makeStyles'
import Button from '@mui/material/Button'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Grid from '@mui/material/Grid'
import Slide from '@mui/material/Slide'
import { CloseButton, ThreeDotProgress } from '../generics'



const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: 30,
    overflowX: 'hidden'
  },
  progress: {
    position: 'absolute'
  },
  title: {
    fontSize: '1.7rem',
    marginBottom: 24,
    marginTop: 24
  },
  bold: {
    fontWeight: 800,
  },
  list: {
    width: '100%'
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: 15
  },
  item: {
    width: '100%',
    padding: 12
  },
  listItemSecondaryAction: {
    width: 150,
    paddingLeft: 12,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  updateButton: {
    fontSize: 11,
    padding: 10,
    backgroundColor: 'black',
    color: 'white',
    '&:hover': {
      backgroundColor: 'black'
    }
  }
}))


const BandPermissions = props => {
  const classes = useStyles()
  const isMounted = useIsMounted()
  const [isFetching, setIsFetching] = useState(true)
  const [permissions, setPermissions] = useState({})
  const [updated, setUpdated] = useState([])
  const { bandId, members, handleClose, showAlert } = props


  useEffect(() => {
    index('bands/' + bandId + '/bandmates/permissions')
      .then(response => {
        if (isMounted.current) {
          setPermissions(response.data)
          setIsFetching(false)
        }
      })
      .catch(error => {
        if (isMounted.current) {
          setPermissions({})
          setIsFetching(false)
        }
      })
  }, [bandId, isMounted])


  const handlePermissionChange = id => e => {
    const newPermissions = { ...permissions, [id]: e.target.value }
    const index = updated.indexOf(id)
    const newUpdated = [...updated]
    
    if (index === -1) {
      newUpdated.push(id)
    } else {
      newUpdated.splice(index, 1)
    }

    setUpdated(newUpdated)
    setPermissions(newPermissions)
  }


  const updateBandPermission = id => () => {
    const newPermission = permissions[id]

    if (newPermission) {
      patch('bands/' + bandId + '/bandmates/permissions', { 
        artist_id: id,
        permission: newPermission
       })
      .then(() => {
        showAlert('Permission has been updated', 'success')
        if (isMounted.current) {
          const newUpdated = [...updated]
          const index = updated.indexOf(id)
          newUpdated.splice(index, 1)
          setUpdated(newUpdated)
        }
      })
      .catch(error => {
        const message = formatError(error).error.messages[0]
        showAlert(message, 'error')
      })
    }
  }

  

  return (
    <div className={ classes.root }>
      <CloseButton onClick={ handleClose } />

      <Typography align='left' className={ classes.title }>
        <span className={ classes.bold }>Change</span> Permissions
      </Typography>

      <Grid container justifyContent='center' alignItems='center'>
      { isFetching 
        ? <ThreeDotProgress position='absolute' />
        : <List className={ classes.list }>
          { Object.values(members).map(artist => {
              const { name, image, imageDerivatives } = artist.attributes
              const imageURL = imageDerivatives.small || image
              const permission = permissions[artist.id]

              return (
                <ListItem
                  disabled={ permission === 'owner' && !updated.includes(artist.id) }
                  key={ artist.id } 
                  className={ classes.item }>

                  <ListItemAvatar>
                    <Avatar className={ classes.avatar } alt='profile' src={ imageURL } />
                  </ListItemAvatar>

                  <ListItemText 
                    primary={ name }
                    primaryTypographyProps={{ noWrap: true }} />

                  <div className={ classes.listItemSecondaryAction }>
                    { (permission === 'owner' && !updated.includes(artist.id))
                      ? <Typography>Owner</Typography>            
                      : <Select
                          color='primary'
                          onChange={ handlePermissionChange(artist.id) }
                          value={ permission }>
                          <MenuItem value='member'>Member</MenuItem>
                          <MenuItem value='editor'>Editor</MenuItem>
                          <MenuItem value='owner'>Owner</MenuItem>
                        </Select>
                    }
                    <Slide 
                      direction='left' 
                      in={ updated.includes(artist.id) } 
                      mountOnEnter 
                      unmountOnExit>
                      <Button
                        className={ classes.updateButton }
                        variant='contained'
                        disableElevation
                        onClick={ updateBandPermission(artist.id) }>
                        UPDATE
                      </Button>
                    </Slide>
                  </div>

                </ListItem>
              )
            })
          }
          </List>
      }
      </Grid>
    </div>
  )
}


export default connect(null, { showAlert })(BandPermissions)

